import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { persistor } from 'src/store/Store';

const initialState = {
    lessonWorkStation: null,
    lvlWorkStation: null,
    workStationDetails: null
};


export const WorkStationSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        getLessonWorkStations: (state, action) => {
            return {
                ...state,
                lessonWorkStation: action.payload
            };
        },
        getLevelWorkStations: (state, action) => {
            return {
                ...state,
                lvlWorkStation: action.payload
            };
        },
        getWorkStationDetails: (state, action) => {
            return {
                ...state,
                workStationDetails: action.payload
            };
        },
    },
});

export const getLessonWorkStation = (type, auth, formData) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
        params: { lesson_id: formData.get("lesson_id") },
    };
    if (type == 'USER') {
        axios
            .get(`https://backend.sophtomeng.com/contents/work_stations/user_list`, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLessonWorkStations(response.data))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}


export const getLevelWorkStation = (type, auth, formData) => async (dispatch) => {
    console.log("girdi", auth);

    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
        params: { level_id: formData.get("level_id") },
    };
    if (type == 'USER') {
        axios
            .get(`https://backend.sophtomeng.com/contents/work_stations/user_list`, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelWorkStations(response.data))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}

export const getWorkStationDetail = (type, auth, id) => async (dispatch) => {
    console.log("girdi", auth);

    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email }
    };
    if (type == 'USER') {
        axios
            .get(`https://backend.sophtomeng.com/contents/work_stations/detail/${id}`, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getWorkStationDetails(response.data))
            }
            )
            .catch(function (error) {
                console.log(error);
                dispatch(getWorkStationDetails(null))
            });
    }
}

export const complatedWorkStation = (type, auth, id) => async (dispatch) => {

    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email }
    };
    if (type == 'USER') {
        axios
            .put(`https://backend.sophtomeng.com/contents/work_stations/user_list/${id}/used`, null,authConfig)
            .then((response) => {
                console.log(response.data);
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}
{/*export const postWorkStation = (type, auth, formData, level_id) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
    };
    console.log(type);

    if (type == 'ADMIN') {
        console.log("istek geldi");

        axios
            .post(`https://backend.sophtomeng.com/contents/work_stations`, formData, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelWorkStation(type, auth, level_id))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}

export const deleteWorkStation = (type, auth, level_id, id) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
    };
    console.log(type);

    if (type == 'ADMIN') {
        console.log("istek geldi");

        axios
            .delete(`https://backend.sophtomeng.com/contents/work_stations/${id}`, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelWorkStation(type, auth, level_id))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}

export const updateWorkStationTitle = (type, auth, formData, level_id, id) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
    };
    console.log(type);

    if (type == 'ADMIN') {
        console.log("istek geldi");

        axios
            .put(`https://backend.sophtomeng.com/contents/work_stations/${id}/title`, formData, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelWorkStation(type, auth, level_id))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}

export const updateWorkStationImage = (type, auth, formData, level_id, id) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
    };
    console.log(type);

    if (type == 'ADMIN') {
        console.log("istek geldi");

        axios
            .put(`https://backend.sophtomeng.com/contents/work_stations/${id}/img`, formData, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelWorkStation(type, auth, level_id))
                dispatch(getWorkStation(type, auth, id))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}

export const updateWorkStationVideo = (type, auth, formData, level_id, id) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
    };
    console.log(type);

    if (type == 'ADMIN') {
        console.log("istek geldi");

        axios
            .put(`https://backend.sophtomeng.com/contents/work_stations/${id}/video`, formData, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelWorkStation(type, auth, level_id))
                dispatch(getWorkStation(type, auth, id))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}

export const updateWorkStationStatus = (type, auth, formData, level_id, id) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
    };
    console.log(type);

    if (type == 'ADMIN') {
        console.log("istek geldi");

        axios
            .put(`https://backend.sophtomeng.com/contents/work_stations/${id}/status`, formData, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelWorkStation(type, auth, level_id))
                dispatch(getWorkStation(type, auth, id))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}

export const updateWorkStationDescription = (type, auth, formData, level_id, id) => async (dispatch) => {
    const authConfig = {
        headers: { Authorization: `Bearer ${auth.token}`, email: auth.email },
    };
    console.log(type);

    if (type == 'ADMIN') {
        console.log("istek geldi");

        axios
            .put(`https://backend.sophtomeng.com/contents/work_stations/${id}/description`, formData, authConfig)
            .then((response) => {
                console.log(response.data);
                dispatch(getLevelWorkStation(type, auth, level_id))
                dispatch(getWorkStation(type, auth, id))
            }
            )
            .catch(function (error) {
                console.log(error);
            });
    }
}*/}



export const {
    getLessonWorkStations,
    getLevelWorkStations,
    getWorkStationDetails
} = WorkStationSlice.actions;

export default WorkStationSlice.reducer;
